import { useState } from 'react';

const useCustomHook = () => {
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [data, setData] = useState(null);

  return {
    submitLoading,
    setSubmitLoading,
    data,
    setData,
    loading,
    setLoading,
  };
};

export default useCustomHook;
